const fields = [
  // {
  //   dataIndex: 'index',
  //   key: 'index',
  //   title: '序号',
  //   width: 80,
  //   scopedSlots: {
  //     customRender: 'subscript'
  //   }
  // },
  {
    dataIndex: 'name',
    key: 'name',
    title: '视频名称',
    width: 190,
    scopedSlots: {
      customRender: 'TextAction'
    }
  },
  {
    dataIndex: 'createBy',
    key: 'createBy',
    title: '创建人',
    width: 120
  },
  {
    dataIndex: 'statusText',
    key: 'statusText',
    title: '状态',
    width: 100,
    scopedSlots: {
      customRender: 'color'
    }
  },
  {
    dataIndex: 'createTime',
    key: 'createTime',
    title: '发布日期',
    width: 120
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 130,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 11,
    label: '课程名称',
    component: 'AInput',
    placeholder: '请输入课程名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 8,
    label: '创建日期',
    component: 'ASelect',
    placeholder: '请选择发布日期',
    prop: 'searchValue',
    list: [
      { label: '全部时间', value: '0' },
      { label: '近一个月', value: '1' },
      { label: '近3个月', value: '2' },
      { label: '近半年', value: '3' },
      { label: '近一年', value: '4' },
      { label: '一年以前', value: '5' }
    ]
  }
  // {
  //   span: 3,
  //   component: 'OtherButton',
  //   btName: '清空条件',
  //   cb: 'clearAll'
  // },
  // {
  //   span: 2,
  //   component: 'OtherButton',
  //   btName: '搜索',
  //   cb: 'toSearch',
  //   customButtonItemStyle: {
  //     color: '#fff',
  //     border: '0px',
  //     background: 'linear-gradient(0deg, #2087FB, #73D3FF)'
  //   }
  // }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction',
    cb: 'toDetail'
  },
  {
    slot: 'action',
    component: 'Action',
    list: [
      { name: '编辑', cb: 'edit' },
      // { name: '发布', cb: 'issue', divider: true },
      { name: '删除', cb: 'singleDelete', divider: true }
    ]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
